import { render } from "./index.vue?vue&type=template&id=b1a8212a"
import script from "./request-message.js?vue&type=script&lang=js"
export * from "./request-message.js?vue&type=script&lang=js"

import "./request-message.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\Users\\devin\\Desktop\\Web\\Portfolios\\Portolio\\vue-personal-portfolio\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__